export const lang = {
    contact: '联系我们',
    name: '贝威科技(潍坊)有限公司',
    add: '地址',
    addInfo: '山东省潍坊市新安街道锦山街与潍徐路交叉口西北侧',
    contactEr: '联系人：郝总',
    Tel: '电话',
    Mobile: '手机',
    Email: '邮箱',
    Website: '网址',
    position: '当前位置',
    Baway: '选择贝威的',
    advantages: '四大优势',
    advantages1: '品牌过硬，足迹遍布各行各业',
    content1: '贝威科技的设备广泛应用于非金属矿材料、水泥、剪裁、磨料、耐火材料、染料、涂料、化工、金属粉末、发光材料、电子材料、陶瓷、农药、造纸、医药、食品、保健品等物料的深加工和分离提取。',
    advantages2: '专业服务，“一站式”解决方案',
    content2: '贝威科技设有专业的实验中心与检测中心，随时准备为客户提供研发协助、技术咨询服务，与客户一起探讨解决各类流体深加工方面的疑难问题，充分利用我们的技术与经验为客户设计提供最佳的工艺与设备，为客户提高效益。',
    advantages3: '全球1500余客户的无二之选',
    content3: '贝威科技的粉碎分离设备、过滤器、工业检测仪表等产品在全球拥有1,500个以上的稳定合作伙伴。',
    advantages4: '精心专研，铸就您的财富未来',
    content4: '贝威科技拥有专业的研发团队，专注流体设备、高端仪器仪表的研发、生产和销售。掌握了多项核心技术，产品深受客户的赞誉和满意。',
    hotline: '全国服务热线',
    Company: '公司简介',
    Foot: '脚踏实地，承载您我',
    Introduction1: '贝威科技是香港Allied Planet Limited和上海贝威科技有限公司的合资子公司。',
    Introduction2: '研发团队专业涉及通信与信息系统、电化学、结构设计、计算机科学、自动化、半导体材料等，均有着多年的产品研发经验，他们不仅能够实现产品的改进、完善、升级和迭代，还能根据客户要求开发新产品，制定合理的解决方案。',
    Introduction3: '发展至今，积极响应国家大的产业规划政策，不断的在技术创新方面取得突破，在科技及创新发展的大潮中，勇于担当，突破自己。多年来始终坚持以科技创新为第一生产力，迎合国家“十四五”发展目标及定位，积极未雨绸缪调整产业布局，不断适应国际及国内新兴产业变革带来的各种影响，进而提升企业核心竞争力。',
    Introduction4: '贝威科技一直秉承“专注产品、精益求精、尊重客户需求”的企业理念和开拓创新的精神，努力为中国流体事业的发展做出贡献。',
    Introduction5: '我们坚信质量和效率体现于微小的细节：工程设计、研发实验、设备生产或者调试，在您项目的每一个阶段，我们都全心付出时刻关注',
    Introduction6: '工厂落户节能环保新材料产业园，投资1.15亿元，产业规划主要是定位于国家环保产业规划中关于水质在线实时检测、水处理等相关产品的研发、销售；',
    Mission: '使命与价值观',
    Mission1: '公司的价值观',
    Mission2: '用科技改变我们的生活，用细节彰显产品的品质，用专注成就我们的事业。',
    Mission3: '企业精神',
    Mission4: '服务！ 创新！ 共赢！',
    Mission5: '营销理念',
    Mission6: '以技术吸引客户！用智慧引领客户！为客户提供有竞争力的解决方案！',
    Mission7: '质量理念',
    Mission8: '质量即人品！',
    Mission9: '企业精神',
    Mission10: '勇于创新 精益求精',
    Product: '产品中心',
    Description: '产品概述',
    technical: '技术参数',
    index: '公司首页',
    Introduction: '公司简介',
    Qualification: '资质认证',
    Customized: '定制化一站式解决方案',
    index1: '首页',
    more: '了解更多',
    check: '查看详情',
    Previous: '上一篇',
    Next: '下一篇',
    Professional: '产品专业，服务专一',
    innovation: '创新',
    Cooperation: '合作',
    win: '共赢',
    development: '产品开发',
    manufacturing: '生产制造',
    market: '市场拓展',
    Support: '支持服务',
    scope: '营业范围',
    Popular: '热门推荐',
    Assurance: '服务承诺 品质保证',
    number: '产品编号',
    model: '产品型号',
    price: '产品价格',
    picture: '图片',
    news: '新闻中心',


}
